import { FINANCIAL_TARGET_ROW_IDS } from "components/product-collection/product-collection-views/product-collection-target-metrics/constants";
import { FinancialTargetReduxState } from "./types";
import { Set } from "immutable";

export const defaultDisplayedRows = {
    [FINANCIAL_TARGET_ROW_IDS.TARGET]: true,
    [FINANCIAL_TARGET_ROW_IDS.TOTAL]: true,
    [FINANCIAL_TARGET_ROW_IDS.VARIANCE]: true,
    [FINANCIAL_TARGET_ROW_IDS.VARIANCE_PERCENTAGE]: true,
};

export const getInitialState = (): FinancialTargetReduxState => {
    return {
        isGridOpen: false,
        selectedTargetIds: Set<string>(),
        displayedRows: defaultDisplayedRows,
        isCollapseModeOn: false,
    };
};
